// Internal
import { saveTableState } from './actions';

export const defaultState = {};

const tableServerSide = (state = defaultState, action) => {
  switch (action.type) {
    case saveTableState.type: {
      const { tableId, tableState } = action.payload;

      return {
        ...state,
        [tableId]: {
          ...tableState
        }
      };
    }

    default:
      return state;
  }
};

export default tableServerSide;
